import { ActionTree, MutationTree } from 'vuex'
import { IRootState } from '@/store'
import { ICMState } from './interfaces/ICMState'
import { CMMutationType } from './interfaces/mutation-type'
import { ICMMutations } from '@/store/modules/containerManager/interfaces/ICMMutation'
import { ICMActions } from './interfaces/ICMAction'
import { CMActionType } from './interfaces/action-type'
import { cmAPI } from './api/getContainer'
import { IGetContainersRequest } from './interfaces/getContainers/IGetContainersRequest'
import { IGetContainersResponse } from './interfaces/getContainers/IGetContainersResponse'

const state = (): ICMState => ({
  loading: false,
  container: {} as IGetContainersResponse
})

const mutations: MutationTree<ICMState> & ICMMutations = {
  [CMMutationType.SET_LOADING] (state: ICMState, payload: boolean) {
    state.loading = payload
  },
  [CMMutationType.SET_CONTAINER] (state: ICMState, payload: any) {
    state.container = payload
  }
}

const actions: ActionTree<ICMState, IRootState> & ICMActions = {
  async [CMActionType.GET_CONTAINER] ({ commit }, dto: IGetContainersRequest) {
    commit(CMMutationType.SET_LOADING, true)
    const data = await cmAPI.fetchContainers(dto)
    try {
      if (data) {
        commit(CMMutationType.SET_CONTAINER, data)
        commit(CMMutationType.SET_LOADING, false)
      }
    } catch (error) {
      commit(CMMutationType.SET_LOADING, false)
      console.error(error)
    }
  },
  async [CMActionType.UPDATE_CONTAINER] ({ commit }, dto: any) {
    commit(CMMutationType.SET_LOADING, true)
    const data = await cmAPI.updateContainers(dto)
    try {
      if (data) {
        commit(CMMutationType.SET_LOADING, false)
      }
    } catch (error) {
      commit(CMMutationType.SET_LOADING, false)
      console.error(error)
    }
  }
}

const containerManager = {
  namespaced: true,
  state,
  mutations,
  actions
}

export default containerManager
